var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      height: "calc(100vh - 150px)",
      display: "flex",
      "flex-direction": "column"
    }
  }, [_c("top-title", {
    attrs: {
      bottom: false
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm.navList.length != 0 ? _c("div", {
    attrs: {
      slot: "btn"
    },
    slot: "btn"
  }, [_c("a-button", {
    on: {
      click: _vm.saveFun
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1) : _vm._e()]), _vm.navList.length != 0 ? _c("div", {
    staticClass: "templateBox"
  }, [_c("div", {
    staticClass: "leftBox"
  }, [_c("a-alert", {
    attrs: {
      message: _vm.$t("拖拽添加模块"),
      banner: "",
      "show-icon": false
    }
  }), _c("div", {
    staticClass: "infoBox"
  }, [_c("div", {
    staticClass: "infoLeftBox"
  }, [_c("div", {
    staticClass: "navBox"
  }, _vm._l(_vm.navList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "navItem",
      class: index == _vm.navIndex ? "hit" : "",
      on: {
        click: function ($event) {
          return _vm.navChange(index);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
  }), 0), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.navIndex != -1,
      expression: "navIndex != -1"
    }],
    staticClass: "navContBox",
    on: {
      scroll: _vm.onScroll
    }
  }, _vm._l(_vm.navList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "navItemBox"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("draggable", {
      attrs: {
        animation: "300",
        group: _vm.grpupA,
        sort: false,
        move: _vm.onMove
      },
      model: {
        value: item.childer,
        callback: function ($$v) {
          _vm.$set(item, "childer", $$v);
        },
        expression: "item.childer"
      }
    }, [_c("transition-group", {
      staticClass: "groupBox"
    }, [_vm.$route.params.type == "INVOICE_DETAIL_PAGE" ? _vm._l(item.childer, function (item2, index2) {
      return item2.mark != "bottomButton1" && item2.mark != "bottomButton2" ? _c("div", {
        key: index2 + 1,
        staticClass: "groupItem"
      }, [_vm._v(" " + _vm._s(_vm.$t(item2.name)) + " "), _c("img", {
        attrs: {
          src: item2.icon,
          alt: ""
        }
      })]) : _vm._e();
    }) : _vm._l(item.childer, function (item2, index2) {
      return _c("div", {
        key: index2 + 1,
        staticClass: "groupItem"
      }, [_vm._v(" " + _vm._s(_vm.$t(item2.name)) + " "), _c("img", {
        attrs: {
          src: item2.icon,
          alt: ""
        }
      })]);
    })], 2)], 1)], 1);
  }), 0)]), _c("div", {
    staticClass: "infoRightBox"
  }, [_c("div", {
    staticClass: "infoContBox",
    style: {
      backgroundImage: `url(${_vm.backgroundImage})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover"
    }
  }, [_c("draggable", {
    attrs: {
      group: {
        name: "site",
        pull: false,
        put: true
      },
      animation: "300",
      sort: false
    },
    on: {
      add: _vm.add2
    },
    model: {
      value: _vm.arr2,
      callback: function ($$v) {
        _vm.arr2 = $$v;
      },
      expression: "arr2"
    }
  }, [_c("transition-group", _vm._l(_vm.arr2, function (item, index) {
    return _c("mobile-preview", {
      key: index + 1,
      attrs: {
        itemObj: item,
        itemIndex: index,
        arrNum: _vm.arr2.length - 1,
        isDisplayNavigation: _vm.isDisplayNavigation,
        themeColor: _vm.themeColor,
        pageType: _vm.$route.params.type,
        pageDescription: _vm.pageDescription,
        pageDescriptionConfig: _vm.pageDescriptionConfig
      },
      on: {
        itemClick: _vm.itemFun,
        itemDel: _vm.itemDelFun,
        itemUp: _vm.upItemFun,
        itemDown: _vm.itemDownFun,
        premiumClick: function ($event) {
          _vm.premiumShow = true;
        },
        buttonModalClick: _vm.onOpenButtonModal
      }
    });
  }), 1)], 1), _vm.premiumShow ? _c("div", [_c("div", {
    staticStyle: {
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.5)",
      position: "absolute",
      left: "0",
      top: "0",
      "z-index": "2"
    },
    on: {
      click: function ($event) {
        _vm.premiumShow = false;
      }
    }
  }), _c("premium-model", {
    attrs: {
      styleObj: _vm.configureObj.style,
      themeColor: _vm.themeColor
    },
    on: {
      premiumClick: _vm.onClickPremium
    }
  })], 1) : _vm._e(), _vm.pageModalShow ? _c("div", [_c("div", {
    staticStyle: {
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.5)",
      position: "absolute",
      left: "0",
      top: "0",
      "z-index": "2"
    },
    on: {
      click: function ($event) {
        _vm.pageModalShow = false;
      }
    }
  }), _c("page-modal", {
    attrs: {
      pagePopUpConfig: _vm.pagePopUpConfig
    },
    on: {
      popupClick: function ($event) {
        _vm.pageModalShow = false;
      }
    }
  })], 1) : _vm._e(), _vm.buttonModalShow ? _c("div", [_c("div", {
    staticStyle: {
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.5)",
      position: "absolute",
      left: "0",
      top: "0",
      "z-index": "2"
    },
    on: {
      click: function ($event) {
        _vm.buttonModalShow = false;
      }
    }
  }), _c("button-modal", {
    attrs: {
      buttonPopUpConfig: _vm.buttonPopUpConfig
    },
    on: {
      popupClick: function ($event) {
        _vm.buttonModalShow = false;
      }
    }
  })], 1) : _vm._e()], 1)])])], 1), _c("div", {
    staticClass: "rightBox"
  }, [_c("configure", {
    attrs: {
      configureObj: _vm.configureObj,
      configureList: _vm.configureList,
      themeColor: _vm.themeColor,
      changeType: _vm.changeType,
      chooseStyleArr: _vm.arr2,
      pageTitle: _vm.pageTypeName
    },
    on: {
      itemChange: _vm.itemChange,
      pageTitleChange: _vm.pageTitleChange
    }
  })], 1)]) : _c("div", {
    staticStyle: {
      "padding-top": "200px"
    }
  }, [_c("a-result", {
    attrs: {
      status: "info",
      "sub-title": _vm.$t("请先配置该页面的控件再进行配置")
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };